import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import BlogItem from "./blog-item"
/* eslint-disable */
const BlogsRecommender = ({ blogs, params, htmlTitle, buttonViewAllBlogs }) => {
  const [blogsData, setBlogsData] = useState([...blogs.data])

  const reRenderBlogs = action => {
    const newBlogsData =
      action === "next"
        ? [blogsData[1], blogsData[2], blogsData[0]]
        : [blogsData[2], blogsData[0], blogsData[1]]
    setBlogsData(newBlogsData)
  }

  return (
    <div className="max-w-screen-2xl mx-7 2xl:mx-auto relative pb-10 lg:pb-20">
      <div dangerouslySetInnerHTML={{ __html: htmlTitle }}></div>
      <div className="lg:hidden text-right my-10">
        <div
          onClick={() => reRenderBlogs("prev")}
          className="mr-5 cursor-pointer inline-block"
        >
          <StaticImage
            src="../../static/images/icon/angle-arrow-left.svg"
            alt="arrow"
          />
        </div>
        <div
          onClick={() => reRenderBlogs("next")}
          className="cursor-pointer inline-block"
        >
          <StaticImage
            src="../../static/images/icon/angle-arrow-right.svg"
            alt="arrow"
          />
        </div>
      </div>
      <div className="gap-x-10 grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1">
        {blogsData.map((blog, index) => (
          <div
            className={`opacity-in ${
              index === 2
                ? "lg:block hidden"
                : index === 1
                ? "sm:block hidden"
                : ""
            }`}
            key={blog.id}
          >
            <BlogItem blog={blog} params={params} lineClamp={2} />
          </div>
        ))}
      </div>
      {buttonViewAllBlogs && (
        <Link
          to={`/${params.location}/blog/`}
          className="btn btn--black block w-max mx-auto mt-20"
        >
          VIEW ALL BLOGS
        </Link>
      )}
    </div>
  )
}

export default BlogsRecommender
